import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import BlogDetail from "./component/BlogDetail";
import Home from './component/Home';
import Demo from "./component/demo";
import About  from "./component/About";
import Services from "./component/Services";
import Contact from "./component/Contact";
import Blog from "./component/Blog";
import Features from "./component/Features";
import Template from "./component/template";
import ScrollToTop from "./component/ScrollToTop";

function App() {
  return (
     <Router>
      <ScrollToTop />
      <Routes>
        <Route path ="/" element={<Template />}>
        <Route path="/" element={<Home />} />
        <Route path="blog/:slug" element={<BlogDetail />} />
         <Route path="demo" element={<Demo />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
          <Route path="blog" element={<Blog />} />
          <Route path="features" element={<Features />} />

         </Route>
      </Routes>
    </Router>
    // <Demo/>
   
  );
}

export default App;
